import * as React from "react";
import ReactECharts from "echarts-for-react";

export default function MeteringChart({ series, metric, timeAggType, chartType }) {
    const periods = [
        ...new Set(series.flatMap((s) => s.sums.map((sum) => sum.from))),
    ].sort();

    const labels = periods.map((p) => {
        if (timeAggType === "y") return p.split("-")[0];
        if (["m", "q"].includes(timeAggType))
            return p.split("-").slice(0, 2).join("-");
        if (timeAggType === "d")
            return new Date(p).toLocaleDateString(undefined, {});
        return new Date(p).toLocaleString(undefined, {});
    });

    const options = {
        grid: {
            top: "5%",
            right: 0,
            left: 80,
        },
        xAxis: {
            data: labels,
        },
        yAxis: {
            min: 0,
        },
        legend: {
            show: true,
            bottom: 0,
            left: "center",
            type: "scroll",
            itemGap: 20,
        },
        tooltip: {
            trigger: "axis",
            confine: true,
            valueFormatter: (value) =>
                typeof value === "number"
                    ? value.toLocaleString(navigator.language, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                      })
                    : value,
        },
        series: series.map((s) => {
            const byPeriod = Object.fromEntries(
                s.sums.map((sum) => [sum.from, sum[metric]]),
            );
            return {
                name: s.name,
                type: chartType === "lines" ? "line" : "bar",
                data: periods.map((p) => byPeriod[p] ?? null),
            };
        }),
    };

    return (
        <React.Fragment>
            {periods.length > 0 && (
                <ReactECharts
                    style={{ width: "95%", height: "90%", paddingLeft: "10px" }}
                    option={options}
                    notMerge={true}
                />
            )}
        </React.Fragment>
    );
}
